import { globals } from "@/core/globals";
import { graphqlClient } from "../../../client";
import queryDocument from "./forwardCartQuery.graphql";
import type { Mutations, MutationsForwardCartArgs } from "@/core/api/graphql/types";

export async function forwardCart(
  cartCode: string,
  senderEmail: string,
  email: string,
  captchaCode: string,
  senderName?: string,
  notes?: string,
  sendCopy?: boolean,
): Promise<boolean> {
  const { storeId } = globals;
  const { data } = await graphqlClient.mutate<Required<Pick<Mutations, "forwardCart">>, MutationsForwardCartArgs>({
    mutation: queryDocument,
    variables: {
      storeId,
      cartCode,
      senderEmail,
      senderName,
      notes,
      sendCopy,
      captchaCode,
      email,
    },
  });

  return data!.forwardCart;
}
